import { render } from "./ListIncidentView.vue?vue&type=template&id=49fe729a"
import script from "./ListIncidentView.vue?vue&type=script&lang=js"
export * from "./ListIncidentView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/GPSviaAIS/GPSviaAIS/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__